import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_81: FaireProductEntity = {
  token: "legacy_prod_abbott-81",
  type: "product",
  name: "Large Watercolour Dream Napkins, 20 Pk",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/83f8bed75bfeb838dfd882d5e72fd445d4af77528c213a7a9e398cc34476f27a.jpeg",
  priceDollars: 12,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
